import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/misc'
import { modalDecorator } from 'helpers/decorators'
import styles from './modal.styl'

const resetStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    WebkitOverflowScrolling: 'touch',
    borderRadius: 0,
    outline: 'none',
    padding: '20px'
  }
}

@modalDecorator({ resetStyles })
class ModalComp extends Component {
  static propTypes = {
    children: PropTypes.any,
    compact: PropTypes.bool,
    className: PropTypes.string,
    minimal: PropTypes.bool,
    onAfterSubmit: PropTypes.func,
    onClose: PropTypes.func,
    closeActionKey: PropTypes.string,
    closeAction: PropTypes.string,
    actionKey: PropTypes.string,
    action: PropTypes.string,
    customActions: PropTypes.bool
  }

  static defaultProps = {
    action: '',
    closeAction: 'Dismiss'
  }

  render() {
    const {
      action,
      actionKey,
      customActions,
      className,
      compact,
      children,
      closeAction,
      closeActionKey,
      onAfterSubmit,
      onClose,
      minimal
    } = this.props

    const contentClass = [styles.modalContent, className || '']

    compact && contentClass.push(styles.modalCompact)
    minimal && contentClass.push(styles.modalMinimal)

    return (
      <div className={contentClass.join(' ')}>
        <div className={styles.innerContent}>
          {children}

          {!customActions && (
            <div className={styles.btns}>
              <Button className={styles.btn} secondary onClick={onClose}>
                {closeActionKey
                  ? <FormattedMessage
                    id={closeActionKey}
                    defaultMessage={closeAction}
                  />
                  : closeAction}
              </Button>
              {action &&
              <Button className={styles.btn} onClick={onAfterSubmit}>
                {actionKey
                  ? <FormattedMessage id={actionKey} defaultMessage={action} />
                  : action}
              </Button>}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default ModalComp
